import * as Types from '../../../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAllHierarchiesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetAllHierarchiesQuery = { hierarchies?: Array<{ id: string, code: string, readRoles?: Array<string> | null, objectSchema?: { id: string, code: string } | null }> | null };

export type GetHierarchyQueryVariables = Types.Exact<{
  ids?: Types.InputMaybe<Array<Types.Scalars['String']> | Types.Scalars['String']>;
  pagination: Types.Pagination;
  sort: Array<Types.Sort> | Types.Sort;
  filter: Array<Types.SearchFilter> | Types.SearchFilter;
  disableNodesTransformation?: Types.InputMaybe<Types.Scalars['Boolean']>;
  originNode?: Types.InputMaybe<Types.OriginNode>;
}>;


export type GetHierarchyQuery = { searchHierarchies: { nodes: { count: number, pageInfo: { hasNextPage: boolean }, edges: Array<{ cursor: string, node: { id: string, code: string, parent: string, parentCode: string, hierarchy: string, hierarchyCode: string, disabled: boolean, nodePublished: Types.CtgStatus, writeRoles?: Array<string> | null, createdAt: number, updatedAt: number, depth?: number | null, contentTypeGroupStatus?: Array<{ code: string, status: Types.CtgStatus }> | null, contents: Array<{ contentType: string, contentTypeGroup: string, type: string, inherited: boolean, contentTypeGroupIndex: number, repeatable?: boolean | null, value?: Array<{ code?: string | null, value: Array<any | null>, languageIsoCode: string, measure?: string | null, approvedValue?: Array<any | null> | null }> | null }>, metadata?: { createdAt?: any | null, updatedAt?: any | null } | null } }> } } };

export type GetHierarchyNodesBaseInfoQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
  filter: Array<Types.SearchFilter> | Types.SearchFilter;
  sort: Array<Types.Sort> | Types.Sort;
  first?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type GetHierarchyNodesBaseInfoQuery = { searchHierarchies: { nodes: { count: number, edges: Array<{ node: { id: string, code: string } }> } } };

export type ExportXlsxqueryMutationVariables = Types.Exact<{
  ids?: Types.InputMaybe<Array<Types.Scalars['String']> | Types.Scalars['String']>;
  sort: Array<Types.Sort> | Types.Sort;
  filter: Array<Types.SearchFilter> | Types.SearchFilter;
  nodeId?: Types.InputMaybe<Types.Scalars['String']>;
  visibleFields?: Types.InputMaybe<Array<Types.Scalars['String']> | Types.Scalars['String']>;
}>;


export type ExportXlsxqueryMutation = { exportXlsx?: string | null };


export const GetAllHierarchiesDocument = gql`
    query GetAllHierarchies {
  hierarchies {
    id
    code
    readRoles
    objectSchema {
      id
      code
    }
  }
}
    `;

/**
 * __useGetAllHierarchiesQuery__
 *
 * To run a query within a React component, call `useGetAllHierarchiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllHierarchiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllHierarchiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllHierarchiesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllHierarchiesQuery, GetAllHierarchiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllHierarchiesQuery, GetAllHierarchiesQueryVariables>(GetAllHierarchiesDocument, options);
      }
export function useGetAllHierarchiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllHierarchiesQuery, GetAllHierarchiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllHierarchiesQuery, GetAllHierarchiesQueryVariables>(GetAllHierarchiesDocument, options);
        }
export type GetAllHierarchiesQueryHookResult = ReturnType<typeof useGetAllHierarchiesQuery>;
export type GetAllHierarchiesLazyQueryHookResult = ReturnType<typeof useGetAllHierarchiesLazyQuery>;
export type GetAllHierarchiesQueryResult = Apollo.QueryResult<GetAllHierarchiesQuery, GetAllHierarchiesQueryVariables>;
export const GetHierarchyDocument = gql`
    query GetHierarchy($ids: [String!], $pagination: Pagination!, $sort: [Sort!]!, $filter: [SearchFilter!]!, $disableNodesTransformation: Boolean, $originNode: OriginNode) {
  searchHierarchies(
    ids: $ids
    pagination: $pagination
    sort: $sort
    filter: $filter
    disableNodesTransformation: $disableNodesTransformation
    originNode: $originNode
  ) {
    nodes {
      count
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          code
          parent
          parentCode
          hierarchy
          hierarchyCode
          disabled
          contentTypeGroupStatus {
            code
            status
          }
          contents {
            contentType
            contentTypeGroup
            type
            inherited
            contentTypeGroupIndex
            repeatable
            value {
              code
              value
              languageIsoCode
              measure
              approvedValue
            }
          }
          nodePublished
          writeRoles
          createdAt
          updatedAt
          metadata {
            createdAt
            updatedAt
          }
          depth
        }
      }
    }
  }
}
    `;

/**
 * __useGetHierarchyQuery__
 *
 * To run a query within a React component, call `useGetHierarchyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHierarchyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHierarchyQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      disableNodesTransformation: // value for 'disableNodesTransformation'
 *      originNode: // value for 'originNode'
 *   },
 * });
 */
export function useGetHierarchyQuery(baseOptions: Apollo.QueryHookOptions<GetHierarchyQuery, GetHierarchyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHierarchyQuery, GetHierarchyQueryVariables>(GetHierarchyDocument, options);
      }
export function useGetHierarchyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHierarchyQuery, GetHierarchyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHierarchyQuery, GetHierarchyQueryVariables>(GetHierarchyDocument, options);
        }
export type GetHierarchyQueryHookResult = ReturnType<typeof useGetHierarchyQuery>;
export type GetHierarchyLazyQueryHookResult = ReturnType<typeof useGetHierarchyLazyQuery>;
export type GetHierarchyQueryResult = Apollo.QueryResult<GetHierarchyQuery, GetHierarchyQueryVariables>;
export const GetHierarchyNodesBaseInfoDocument = gql`
    query GetHierarchyNodesBaseInfo($id: String!, $filter: [SearchFilter!]!, $sort: [Sort!]!, $first: Int = 50) {
  searchHierarchies(
    ids: [$id]
    filter: $filter
    pagination: {first: $first}
    sort: $sort
  ) {
    nodes {
      count
      edges {
        node {
          id
          code
        }
      }
    }
  }
}
    `;

/**
 * __useGetHierarchyNodesBaseInfoQuery__
 *
 * To run a query within a React component, call `useGetHierarchyNodesBaseInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHierarchyNodesBaseInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHierarchyNodesBaseInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetHierarchyNodesBaseInfoQuery(baseOptions: Apollo.QueryHookOptions<GetHierarchyNodesBaseInfoQuery, GetHierarchyNodesBaseInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHierarchyNodesBaseInfoQuery, GetHierarchyNodesBaseInfoQueryVariables>(GetHierarchyNodesBaseInfoDocument, options);
      }
export function useGetHierarchyNodesBaseInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHierarchyNodesBaseInfoQuery, GetHierarchyNodesBaseInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHierarchyNodesBaseInfoQuery, GetHierarchyNodesBaseInfoQueryVariables>(GetHierarchyNodesBaseInfoDocument, options);
        }
export type GetHierarchyNodesBaseInfoQueryHookResult = ReturnType<typeof useGetHierarchyNodesBaseInfoQuery>;
export type GetHierarchyNodesBaseInfoLazyQueryHookResult = ReturnType<typeof useGetHierarchyNodesBaseInfoLazyQuery>;
export type GetHierarchyNodesBaseInfoQueryResult = Apollo.QueryResult<GetHierarchyNodesBaseInfoQuery, GetHierarchyNodesBaseInfoQueryVariables>;
export const ExportXlsxqueryDocument = gql`
    mutation ExportXlsxquery($ids: [String!], $sort: [Sort!]!, $filter: [SearchFilter!]!, $nodeId: String, $visibleFields: [String!]) {
  exportXlsx(
    ids: $ids
    sort: $sort
    filter: $filter
    nodeId: $nodeId
    visibleFields: $visibleFields
  )
}
    `;
export type ExportXlsxqueryMutationFn = Apollo.MutationFunction<ExportXlsxqueryMutation, ExportXlsxqueryMutationVariables>;

/**
 * __useExportXlsxqueryMutation__
 *
 * To run a mutation, you first call `useExportXlsxqueryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportXlsxqueryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportXlsxqueryMutation, { data, loading, error }] = useExportXlsxqueryMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      nodeId: // value for 'nodeId'
 *      visibleFields: // value for 'visibleFields'
 *   },
 * });
 */
export function useExportXlsxqueryMutation(baseOptions?: Apollo.MutationHookOptions<ExportXlsxqueryMutation, ExportXlsxqueryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportXlsxqueryMutation, ExportXlsxqueryMutationVariables>(ExportXlsxqueryDocument, options);
      }
export type ExportXlsxqueryMutationHookResult = ReturnType<typeof useExportXlsxqueryMutation>;
export type ExportXlsxqueryMutationResult = Apollo.MutationResult<ExportXlsxqueryMutation>;
export type ExportXlsxqueryMutationOptions = Apollo.BaseMutationOptions<ExportXlsxqueryMutation, ExportXlsxqueryMutationVariables>;